import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { Context } from "../../Utils/Wrapper";
import './LanguageSelector.css';
import { injectIntl } from 'react-intl';

function LanguageSelection({intl}) {

    const [selected, setSelected] = useState('');
    const context = useContext(Context);
    const { formatMessage } = intl;
    let options = [
        { value: 'en', label: 'English' },
        { value: 'es', label: 'Spanish' }
    ];


    useEffect(() => {
        if(context.locale === 'es'){
            setSelected(options[1]);
        }
        else {
            setSelected(options[0]);
        }
    }, []);

    const handleSelect = (val) => {
        context.selectLanguage(val);
        setSelected(val);
    }
    return (
        <>
            <h5 className="mt-3 settings-tittle">{formatMessage({ id: "app.language_preference" })}</h5>
            <div className="mb-1" >
                <Select
                    name="form-field-name"
                    value={selected}
                    options={options}
                    onChange={handleSelect}
                    style={{ paddingRight: '5px' }}
                    className='language-selector'
                />
            </div>
        </>
    )
}

export default injectIntl(LanguageSelection);